const URL = "https://be-grintect-dev-2gasck3fsa-as.a.run.app/api";

export { URL };
